import 'zustand'
import { IConfigurationState, initialConfigState } from '../interfaces/configuration';
import { create } from "zustand/react";
import IGraphUserProfileState from "../interfaces/graphUserProfile";
import { IGenericErrorState, initGenericErrorState } from "../interfaces/genericError";
import { IMeState, initialMeState } from "../interfaces/me";
import { DateFilterRange, InitialDateFilterRange } from "../interfaces/dateFilterRange";

interface AppStore {
    configuration: IConfigurationState,
    genericError: IGenericErrorState,
    me: IMeState,
    profile: IGraphUserProfileState,
    dateRangeFilter: DateFilterRange
}

const useStore = create<AppStore>(
    (set) => ({
        configuration: initialConfigState,
        genericError: initGenericErrorState,
        me: initialMeState,
        profile: {} as IGraphUserProfileState,
        dateRangeFilter: InitialDateFilterRange
    })
);

export interface IStateMachine {
    status: 'idle' | 'pending' | 'succeeded' | 'failed'
    error: string
}

export { useStore }
